import { useMcpClient } from "./api/get-mcp-client";

/** Used wherever the client couldn't be named — "MCP client" is jargon the user didn't sign up for. */
export const GENERIC_CLIENT = "your agent";

/**
 * Fallback for desktop clients whose OAuth callback is a localhost or custom-scheme URL:
 * the hostname names them when the registered client_name isn't available.
 */
const MCP_CLIENT_NAMES: Record<string, string> = {
  "claude.ai": "Claude",
  "anthropic.com": "Claude",
  "chatgpt.com": "ChatGPT",
  "openai.com": "ChatGPT",
  "cursor.com": "Cursor",
  "cursor.sh": "Cursor",
  "windsurf.com": "Windsurf",
};

export const clientNameFromCallbackUrl = (callbackUrl: string | null): string | null => {
  if (!callbackUrl) return null;
  try {
    const { hostname } = new URL(callbackUrl);
    const domain = Object.keys(MCP_CLIENT_NAMES).find(d => hostname === d || hostname.endsWith(`.${d}`));
    return domain ? MCP_CLIENT_NAMES[domain] : null;
  } catch {
    return null;
  }
};

/**
 * The LLM client the visitor arrived from — "Claude", "ChatGPT", "Cursor" — never the data
 * provider. The name the client registered with beats guessing from the callback host, but
 * the registration lives under the OAuth state and is gone once that ages out.
 */
export const useMcpClientName = (state: string | null, callbackUrl: string | null): string | null => {
  const { data } = useMcpClient(state);
  return data?.mcpClient || clientNameFromCallbackUrl(callbackUrl);
};
